import { render, staticRenderFns } from "./AddNewMistake.vue?vue&type=template&id=49e66786&scoped=true&"
import script from "./AddNewMistake.vue?vue&type=script&lang=js&"
export * from "./AddNewMistake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e66786",
  null
  
)

export default component.exports